import { LogoMark } from "./Logo";
import { scrollToSection } from "../lib/scroll";

export const Footer = () => (
  <footer className="grain relative bg-ink pb-10 pt-16 text-paper/60" data-testid="footer">
    <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col justify-between gap-10 border-b border-paper/10 pb-10 md:flex-row md:items-end">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark className="h-11 w-11" />
            <p className="font-display text-4xl font-medium tracking-tight text-paper sm:text-5xl">
              AssisDent
            </p>
          </div>
          <p className="mt-3 max-w-sm text-sm leading-relaxed">
            Dental care, one tap away — 5,000+ clinics across the USA, booked in seconds.
          </p>
        </div>
        <div className="space-y-2.5 text-sm">
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-paper/40">
            Explore
          </p>
          <a
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("about");
            }}
            className="block transition-colors hover:text-paper"
          >
            About us
          </a>
          <a
            href="#register"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("register");
            }}
            className="block transition-colors hover:text-paper"
          >
            Book now
          </a>
        </div>
        <div className="space-y-2.5 text-sm">
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-paper/40">
            Support
          </p>
          <a
            href="mailto:app@assisdent.info"
            data-testid="footer-support-link"
            className="block transition-colors hover:text-paper"
          >
            app@assisdent.info
          </a>
          <p className="text-paper/40">We&apos;re happy to help</p>
        </div>
      </div>
      <div className="pt-6 font-mono text-[11px] text-paper/35">
        <p>© AssisDent — All rights reserved</p>
      </div>
    </div>
  </footer>
);
